import { Box, CircularProgress } from '@mui/material';

/** What a blocked user sees while the dialog is on its way. */
export const LegalWaiting = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 12 }}>
        <CircularProgress aria-label="Loading legal documents" />
    </Box>
);
